import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useParams, useSearchParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callRegionSelectGet } from "../../../config/actions/regions"
import { callUserRegionListGet, callUserRegionPost, callUserRegionDelete } from "../../actions/user-regions"
import Swal from 'sweetalert2'
import TableView from "../../../../common/containers/TableView"

let UserCompany = ({ setPageAttr, methods: { callUserRegionListGet, callUserRegionPost, callUserRegionDelete, callRegionSelectGet }, list, regionsSelect }) => {
    const params = useParams()
    const [userId] = useState(!params.userId ? '' : params.userId)
    let [searchParams] = useSearchParams();
    const [regionId, setRegionId] = useState('')

    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callUserRegionDelete(userId, id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callUserRegionListGet(userId, {}, pg)
                })
            }
        })
    }

    useEffect(() => {
        callRegionSelectGet()
        let tabs = [
            {
                active: false,
                to: '/users',
                label: 'Informações'
            },
            {
                active: false,
                to: '/users/edit/' + userId,
                label: 'Editar'
            },
            {
                active: false,
                to: '/users/companies/' + userId,
                label: 'Empresas'
            },
            {
                active: true,
                to: '/users/regions/' + userId,
                label: 'Regiões'
            }
        ]

        setPageAttr({
            title: 'Usuário - Empresa - Editar',
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, userId, callRegionSelectGet])

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callUserRegionListGet(userId, {}, pg)
    }, [callUserRegionListGet, searchParams, userId])

    const finishedSubmit = () => {
        setRegionId('')
        
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callUserRegionListGet(userId, {}, pg)
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            regionId: parseInt(regionId)
        }
        callUserRegionPost(userId, data, () => finishedSubmit())
    }

    const headers = [
        {
            type: 'info',
            name: 'region',
            align: 'left',
            label: 'Região'
        },
        {
            type: 'info',
            name: 'author',
            align: 'left',
            label: 'Criado por'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-4 form-group">
                    <label className="required">Região:</label>
                    <select className="form-control" value={regionId} onChange={e => setRegionId(e.target.value)}>
                        <option value=''>Selecione</option>
                        {regionsSelect.map((a, ai) => (
                            <option key={ai} value={a.id}>{a.description}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2">
                    <label>&nbsp;</label><br />
                    <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-plus fa-white"></i>Adicionar</button>
                </div>
            </div>
            <div className="mt-3">
                <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/users/regions/' + userId} />
            </div>
        </form>
    )
}

const mapStateToProps = ({ register: { userRegions: { list }, companies }, config: { regions } }) => ({
    list: list,
    regionsSelect: regions.select
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callUserRegionListGet,
            callUserRegionPost,
            callUserRegionDelete,
            callRegionSelectGet
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCompany)